"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.sportCountersProviderActions = exports.initialState = void 0;
const toolkit_1 = require("../../utils/@reduxjs/toolkit");
const api_1 = require("../../utils/api");
const slices_1 = require("../../utils/@reduxjs/slices");
const utils_1 = require("./utils");
const REDUCER_KEY = 'sportCountersProvider';
// The initial state of the SportCountersProvider container
exports.initialState = (0, slices_1.getPreloadedState)(REDUCER_KEY, {
    live: {
        fetchItems: api_1.requestInitialState,
        entries: {},
    },
    line: {
        fetchItems: api_1.requestInitialState,
        entries: {},
    },
    eventSportCounters: {},
    eventResultCounters: {},
});
const sportCountersProviderSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        fetchSportCounters(_state, _action) { },
        fetchLiveSportCounters(state, _action) {
            state.live.fetchItems.loading = true;
            state.live.fetchItems.error = null;
        },
        liveSportCountersChanged(state, action) {
            state.live.entries = action.payload;
        },
        fetchLiveSportCountersSuccess(state) {
            state.live.fetchItems.loading = false;
            state.live.fetchItems.error = null;
        },
        fetchLiveSportCountersError(state, action) {
            state.live.fetchItems.loading = false;
            state.live.fetchItems.error = action.payload;
        },
        fetchLineSportCounters(state, _action) {
            state.line.fetchItems.loading = true;
            state.line.fetchItems.error = null;
        },
        lineSportCountersChanged(state, action) {
            state.line.entries = action.payload;
        },
        fetchLineSportCountersSuccess(state) {
            state.line.fetchItems.loading = false;
            state.line.fetchItems.error = null;
        },
        fetchLineSportCountersError(state, action) {
            state.line.fetchItems.loading = false;
            state.line.fetchItems.error = action.payload;
        },
        fetchEventsSportCounters(state, action) {
            const { key } = action.payload;
            (0, utils_1.setLoadingEventCounterState)(state.eventSportCounters, key);
        },
        eventSportCountersChanged(state, action) {
            const { data, key } = action.payload;
            (0, utils_1.updateEventCounterState)(state.eventSportCounters, key, data);
        },
        fetchEventSportCountersSuccess(state, action) {
            const { key } = action.payload;
            (0, utils_1.setSuccessEventCounterState)(state.eventSportCounters, key);
        },
        fetchEventSportCountersError(state, action) {
            const { key, error } = action.payload;
            (0, utils_1.setErrorEventCounterState)(state.eventSportCounters, key, error);
        },
        fetchEventResultCountersV2(state, action) {
            const { key } = action.payload;
            (0, utils_1.setLoadingEventCounterState)(state.eventResultCounters, key);
        },
        fetchEventResultCounters(state, action) {
            const { key } = action.payload;
            (0, utils_1.setLoadingEventCounterState)(state.eventResultCounters, key);
        },
        eventResultCountersChanged(state, action) {
            const { data, key } = action.payload;
            (0, utils_1.updateEventCounterState)(state.eventResultCounters, key, data);
        },
        fetchEventResultCountersSuccess(state, action) {
            const { key } = action.payload;
            (0, utils_1.setSuccessEventCounterState)(state.eventResultCounters, key);
        },
        fetchEventResultCountersError(state, action) {
            const { key, error } = action.payload;
            (0, utils_1.setErrorEventCounterState)(state.eventResultCounters, key, error);
        },
    },
});
exports.sportCountersProviderActions = sportCountersProviderSlice.actions, exports.reducer = sportCountersProviderSlice.reducer, exports.sliceKey = sportCountersProviderSlice.name;
//# sourceMappingURL=slice.js.map